/*
* @Author: wanchuan
* @Date:   2017-03-23 15:29:58
* @Last Modified by:   cdwanchuan
* @Last Modified time: 2017-06-22 14:56:36
*/

'use strict';

import * as timing from './timing';
import * as browser from './browser';
//import {error} from './error';
/**
 * 上报Performance timing数据；
 * eg：http://act-jshop.jd.com/plog?a=1&b=2&c=3&d=4&e=5&f=6&g=111&h=112&i=113&appName=sale&token=fe3e88sk3n&url=https://sale.jd.com/act/UGwXRYhBipTNZe7.html
 */


function setTimingRpt(){
	var appName = 'sale',
		url = location.href;

	var timingTime = timing.getTimes(),
		appcacheTime = timingTime.appcacheTime,//（APP CACHE 耗时）a
		connectTime = timingTime.connectTime,//（TCP 链接耗时）b
		domReadyTime = timingTime.domReadyTime,//（解析 dom 树耗时）c
		initDomTreeTime = timingTime.initDomTreeTime,// d
		loadEventTime = timingTime.loadEventTime,//（抛出load事件）e
		loadTime = timingTime.loadTime,//（总耗时）f
		lookupDomainTime = timingTime.lookupDomainTime,//（DNS查询耗时（DNS寻址时间））g
		requestTime = timingTime.requestTime,//（请求耗时（内容加载耗时））h
		showTime = timingTime.showTime,//白屏时间（请求响应耗时） i
		domReady = timingTime.domReady;// 时间 j
	
	var url = '//act-jshop.jd.com/plog?lt=1' + '&a=' + appcacheTime + '&b=' + connectTime + '&c=' + domReadyTime + '&d=' + initDomTreeTime + '&e=' + loadEventTime + '&f=' + loadTime + '&g=' + lookupDomainTime + '&h=' + requestTime + '&i=' + showTime + '&j=' + domReady + '&l=' + browser.terminal() + '&o=' + jQuery('html').html().length + '&q=' + browser.kernel() + '&t=' + jQuery.browser.version + '&appName=' + appName + '&token=' + 'fe3e88sk3n' + '&url=' + url;   
	
	var _img = new Image();
	setTimeout(function(){
		_img.src = url;
	}, 10);      
};

//页面加载完成之后执行
$(window).bind('load',function(){
	setTimeout(function(){
		setTimingRpt();
	}, 0); 
});




// WEBPACK FOOTER //
// ./src/performance/index.js